module.exports = __webpack_public_path__ + "static/media/1.0472046.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/1.mp3
// module id = fSgI
// module chunks = 2